import React, { Component } from 'react'
import { connect } from 'react-redux'
import UploadModal from '../upload/UploadModal'
import UploadActions from '../redux/uploadRedux'

class UploadContainer extends Component {
  handleRequestClose = () => {
    const { actions } = this.props

    actions.uploadClosed()
  }

  render () {
    const { open } = this.props
    return (
      <UploadModal open={open} onRequestClose={this.handleRequestClose}  />
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.upload.open
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      uploadClosed: () => dispatch(UploadActions.uploadClosed())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadContainer)



// WEBPACK FOOTER //
// ./src/containers/UploadContainer.js